/* eslint-disable no-console */
import {
  Autocomplete,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  LinearProgress,
  Switch,
  Typography
} from '@mui/material';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import config from 'src/appConfig';
import { usePermissionWrapper } from 'src/components/common/hooks/usePermissionWrapper';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useGetStudiesQuery } from 'src/components/Services/Utils';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import IncludePHIDialog from '../documentUpload/IncludePHIDialog';
import { RedactedCertifiedDialog } from '../documentUpload/RedactedCertifiedDialog';
import DocManagementService from '../documentUpload/service/DocManagementService';
import { EditMetaDataProps } from './types';

const EditMetadataModal = ({ documentProps, setDocumentMeta, setOpenEdit }: EditMetaDataProps) => {
  const [metaData, setMetaData] = useState(documentProps);
  const [artifactNameList, setArtifactNameList] = useState<any>([]);
  const [artifactName, setArtifactName] = useState<any>();
  const [list, setList] = useState([]);
  const [studyList, setStudyList] = useState<any>([]);
  const docService = new DocManagementService();
  const dispatch = useDispatch();
  const [isVersionCheck, setIsVersionCheck] = useState(false);
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const [checked, setChecked] = useState(false);
  const [openPHI, setOpenPHI] = useState(false);
  const [docName, setDocName] = useState<any>();
  const { checkPermission } = usePermissionWrapper();
  const [isProcessing, setProcessing] = useState(false);
  const [disablePHI, setDisablePHI] = useState(false);
  const SearchHierarchyDetail: any = useSelector((state: AppState) => state.searchHierarchyDetails);
  const [open, setOpen] = React.useState(false);
  const [openConfirmExit, setOpenConfirmExit] = useState(false);
  const isfInstance = axios.create({ baseURL: `${config.appConfig.apiisf}` });
  const newState = store.getState();
  const headerConfig = {
    headers: {
      sponsor: newState.user.user?.sponsor_sponsor_name,
      Sponsor_token: newState.user.user?.sponsorToken,
      Authorization: `Bearer ${newState.user.user?.token}`
    }
  };
  const handleClose = () => {
    if (JSON.stringify(metaData) !== JSON.stringify(documentProps)) {
      setOpenConfirmExit(true);
    } else {
      setOpenEdit(false);
      setOpenConfirmExit(false);
    }
  };

  const {
    isLoading: getStudyLoad,
    data: studyData,
    isError: getStudyError,
    isSuccess: getStudySuccess,
    refetch: getStudyList
  } = useGetStudiesQuery();

  useEffect(() => {
    getStudyList();
    // getIsfDataResponse(metaData.isf_doc_level);
    handleStudyChange(metaData.isf_doc_study);
  }, []);

  useEffect(() => {
    const temp: string[] = [];
    if (studyData && studyData.length !== 0) {
      studyData.map((study: any) => {
        temp.push(study.name);
      });
    }
    setStudyList(temp);
  }, [studyData]);

  const date = moment(new Date(metaData.isf_doc_viewer_date)).format(userPreferedDateFormat.toUpperCase());

  const handleDocumentName = (e: any) => {
    setMetaData({ ...metaData, isf_document_name: e.target.value });
    setDocName(e.target.value);
  };

  const handleChangeCheck = () => {
    setOpenPHI(true);
  };

  const handleClosePHI = () => {
    setOpenPHI(false);
  };

  const handleStudyChange = async (e: any) => {
    const result = await docService.getStudyList(e.target.value);
    setMetaData({
      ...metaData,
      isf_doc_site: result.data.site_id,
      isf_doc_country: result.data.country,
      isf_doc_study: result.data.study_id
    });
  };

  const getArtifactNameList = async (study: string, country: string, site: string) => {
    const result: any = await docService.getArtifactsList(
      metaData.isf_doc_level,
      study,
      country,
      site,
      process.env.REACT_APP_NAME,
      'DocumentDetails',
      metaData.isf_document_name
    );
    if (result.data) {
      setArtifactNameList(result.data);
      setList(result.data);
    }
  };

  const handleChangeArtifactName = (e: any) => {
    if (e && e !== '') {
      setArtifactName(e);
      getArtifactNameResponse(e);
    } else {
      setMetaData({
        ...metaData,
        isf_artifact_name: '',
        isf_doc_milestone: '',
        isf_doc_type: '',
        isf_doc_subtype: '',
        isf_artifact_number: ''
      });
    }
  };

  const handleClickArtifactName = (e: any) => {
    if ((e.target.value && e.target.value === '') || e.target.value === undefined) {
      setMetaData({
        ...metaData,
        isf_doc_milestone: '',
        isf_doc_type: '',
        isf_doc_subtype: '',
        isf_artifact_number: ''
      });
    } else {
      getArtifactNameList(
        SearchHierarchyDetail?.data[0]?.Study,
        SearchHierarchyDetail?.data[0]?.Country,
        SearchHierarchyDetail?.data[0]?.Site
      );
      setMetaData({
        ...metaData,
        isf_artifact_name: e.target.value
      });
    }
  };

  const getArtifactNameResponse = async (artifactName: any) => {
    const result = await docService.getArtifactNameResponse(
      metaData.isf_doc_level,
      artifactName,
      SearchHierarchyDetail?.data[0]?.Study,
      SearchHierarchyDetail?.data[0]?.Country,
      SearchHierarchyDetail?.data[0]?.Site,
      process.env.REACT_APP_NAME,
      'DocumentDetails',
      metaData.isf_document_name
    );
    setMetaData({
      ...metaData,
      isf_artifact_number: result.data.isf_artifact_number,
      isf_doc_subtype: result.data.isf_doc_subtype,
      isf_doc_type: result.data.isf_doc_type,
      isf_doc_milestone: result.data.isf_doc_milestone,
      isf_artifact_name: artifactName
    });
  };

  const updateRedactCopyValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOpen(true);
  };

  const handleUpdateFile = async (Meta: any) => {
    const docData: any = {
      file_master_id: Meta.fileId,
      document_data: {
        isf_artifact_number: Meta?.isf_artifact_number,
        isf_doc_subtype: Meta?.isf_doc_subtype,
        isf_doc_milestone: Meta?.isf_doc_milestone,
        isf_doc_type: Meta?.isf_doc_type,
        isf_artifact_name: Meta?.isf_artifact_name,
        isf_doc_site: Meta?.isf_doc_site,
        isf_doc_country: Meta?.isf_doc_country,
        isf_doc_study: Meta?.isf_doc_study,
        isf_document_name: Meta?.isf_document_name.trim(),
        isf_doc_level: Meta?.isf_doc_level,
        isf_doc_status: Meta?.isf_doc_status,
        isf_doc_viewer_req_certified_copy: Meta.isf_doc_viewer_req_certified_copy,
        isf_doc_viewer_red_certified_copy: Meta.isf_doc_viewer_red_certified_copy
          ? Meta.isf_doc_viewer_red_certified_copy
          : 'N',
        isf_doc_viewer_doc_phi_redacted: Meta.isf_doc_viewer_doc_phi_redacted
          ? Meta.isf_doc_viewer_doc_phi_redacted
          : 'N',
        isf_doc_viewer_department: Meta.isf_doc_viewer_department,
        isf_doc_viewer_language: 'English',
        isf_doc_viewer_approval_cycle: 0,
        isf_doc_viewer_product_detail: '',
        isf_doc_viewer_ref_model_version: 'ISF RM v1.0',
        isf_doc_viewer_format: Meta.isf_doc_format,
        isf_doc_viewer_inspection_ready: 'test1',
        isf_doc_viewer_ir_issue_type: 'test1',
        isf_document_id: Meta.isf_document_id,
        isf_doc_viewer_includes_phi: checked,
        id: Meta.id,
        isf_doc_viewer_last_modified_by: userName,
        isf_doc_version_number: Meta.isf_doc_version_number
      }
    };
    getDocumentDetails(Meta, docData);
  };

  const postData = async (docData: any) => {
    setProcessing(true);
    await isfInstance.put(`${config.appConfig.apiisf}/masterDocument/inlineUpdate`, docData, headerConfig).then(res => {
      setDocumentDetail(dispatch, [
        {
          ...metaData,
          isf_artifact_number: metaData.isf_artifact_number,
          isf_doc_subtype: metaData.isf_doc_subtype,
          isf_doc_milestone: metaData.isf_doc_milestone,
          isf_doc_type: metaData.isf_doc_type,
          isf_artifact_name: res?.data?.document_data?.isf_artifact_name,
          isf_doc_site: metaData.isf_doc_site,
          isf_doc_country: metaData.isf_doc_country,
          isf_doc_study: metaData.isf_doc_study,
          isf_document_name: metaData.isf_document_name.trim(),
          isf_doc_level: metaData.isf_doc_level,
          isf_doc_viewer_last_modified_by: res?.data?.document_data?.isf_doc_viewer_last_modified_by,
          isf_doc_viewer_includes_phi: res?.data?.document_data?.isf_doc_viewer_includes_phi,
          isf_doc_viewer_doc_phi_redacted: res?.data?.document_data?.isf_doc_viewer_doc_phi_redacted,
          isf_doc_status: res?.data?.document_data?.isf_doc_status
        }
      ]);

      if (res.status !== 200) {
        setProcessing(false);
        store.dispatch(setSnackbarMessage('Error in uploading document', 'error'));
        setOpenEdit(false);
        setOpenConfirmExit(false);
      } else {
        store.dispatch(setSnackbarMessage('Document is updated successfully', 'success'));

        const response = res.data.document_data;
        const finalDocData = { ...documentProps, ...response };
        setProcessing(false);
        setDocumentMeta(finalDocData);
        setOpenEdit(false);
        setOpenConfirmExit(false);
      }
    });
  };

  // Version logic //
  const getDocumentDetails = async (metaData: any, docData: any) => {
    const is_scope = metaData.isf_doc_study === '--' ? false : true;
    const country =
      metaData.isf_doc_level === 'Country' || metaData.isf_doc_level === 'Site' ? metaData.isf_doc_country : '--';
    const site = metaData.isf_doc_level === 'Site' ? metaData.isf_doc_site : '--';
    const data = {
      query_filters: [
        {
          name: 'isf_doc_level',
          value: metaData.isf_doc_level,
          operation: 'equals'
        },
        {
          name: 'isf_artifact_name',
          value: artifactName ? artifactName : metaData.isf_artifact_name,
          operation: 'equals'
        }
      ],
      filter_types: ['All']
    };
    const res: any = await docService.getSearchResult(
      data,
      metaData.isf_doc_study,
      metaData.isf_doc_country,
      metaData.isf_doc_site,
      metaData.isf_doc_level,
      is_scope,
      process.env.REACT_APP_NAME,
      'DocumentDetails',
      metaData.isf_document_name
    );
    if (res.data && !isVersionCheck) {
      const condition =
        (metaData.isf_doc_level === res.data?.selected_data[0]?.document_data.isf_doc_level &&
          metaData.isf_doc_study === res.data?.selected_data[0]?.document_data.isf_doc_study &&
          metaData.isf_artifact_name === res.data?.selected_data[0]?.document_data.isf_artifact_name) ||
        metaData.isf_doc_country === res.data?.selected_data[0]?.document_data.isf_doc_country ||
        metaData.isf_doc_site === res.data?.selected_data[0]?.document_data.isf_doc_site;
      if (artifactName === undefined && docName !== '') {
        postData(docData);
      } else if (artifactName === undefined && metaData.isf_doc_viewer_includes_phi !== checked) {
        postData(docData);
      } else {
        condition
          ? store.dispatch(
              setSnackbarMessage(
                'Document exists with same context. Please select different values to proceed',
                'error'
              )
            )
          : postData(docData);
      }
    } else {
      postData(docData);
    }
  };

  useEffect(() => {
    if (Number(metaData.isf_doc_version_number) > 1.0 || metaData.isf_doc_status === 'Approved') {
      setIsVersionCheck(true);
    } else {
      setIsVersionCheck(false);
    }
    getArtifactNameList(
      SearchHierarchyDetail?.data[0]?.Study,
      SearchHierarchyDetail?.data[0]?.Country,
      SearchHierarchyDetail?.data[0]?.Site
    );
    setChecked(metaData.isf_doc_viewer_includes_phi);
  }, []);
  return (
    <>
      <div className="document-upload-modal">
        <div className="card">
          <Grid container spacing={3}>
            <Grid item xs={8}>
              <Typography variant="h5" gutterBottom component="div">
                Edit Metadata
              </Typography>
            </Grid>
            <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <FormControlLabel
                disabled={!checked || metaData.isf_doc_viewer_red_certified_copy === 'Y'}
                value={metaData.isf_doc_viewer_red_certified_copy}
                control={
                  <Switch
                    color="primary"
                    onChange={updateRedactCopyValue}
                    inputProps={{ 'aria-label': 'controlled' }}
                    checked={metaData.isf_doc_viewer_red_certified_copy === 'Y' ? true : false}
                  />
                }
                label="Redacted Certified Copy?"
                labelPlacement="end"
              />

              {/* {!checkPermission('update_required_certificate_copy') && (
              <FormControlLabel
                disabled={!checkPermission('update_required_certificate_copy')}
                value={metaData.tmf_doc_viewer_req_certified_copy}
                control={
                  <Switch
                    color="primary"
                    onChange={updateReqCopyValue}
                    inputProps={{ 'aria-label': 'controlled' }}
                    checked={metaData.tmf_doc_viewer_req_certified_copy == 'Y' ? true : false}
                  />
                }
                label="Require Certified Copy?"
                labelPlacement="end"
              />
            )} */}
            </Grid>
            <Grid item md={12}>
              {isProcessing && <LinearProgress />}
            </Grid>
            <Grid item md={4} sx={{ paddingTop: '0 !important' }}>
              <FormControl fullWidth margin="normal">
                <TextField
                  required
                  id="standard-select-currency-native"
                  label="Document Name"
                  defaultValue={metaData.isf_document_name}
                  variant="standard"
                  onChange={e => handleDocumentName(e)}
                  inputProps={{
                    maxLength: 200
                  }}
                  value={metaData.isf_document_name?.trimLeft()}
                />
              </FormControl>
              <FormControl fullWidth margin="normal">
                <TextField
                  disabled
                  id={documentProps.isf_doc_version_number}
                  label="Version Number"
                  variant="standard"
                  value={parseFloat(metaData.isf_doc_version_number).toFixed(1)}
                  onChange={e => setMetaData({ ...metaData, isf_doc_version_number: e.target.value })}
                />
              </FormControl>
              <FormControl fullWidth margin="normal">
                <TextField
                  disabled={isVersionCheck}
                  id={documentProps.isf_artifact_number}
                  label="Artifact Number"
                  variant="standard"
                  defaultValue={metaData.isf_artifact_number}
                  value={metaData.isf_artifact_number}
                />
              </FormControl>
            </Grid>
            <Grid item md={4} sx={{ paddingTop: '0 !important' }}>
              {/* <FormControl fullWidth margin="normal">
              <TextField
                disabled={isVersionCheck}
                required
                id={documentProps.isf_doc_level}
                select
                label="ISF Level"
                defaultValue={metaData.isf_doc_level}
                value={metaData.isf_doc_level}
                variant="standard"
                onChange={e => {
                  handlechangeIsfLevel(e);
                }}
              >
                <MenuItem value="Study">Study</MenuItem>
                <MenuItem value="Country">Country</MenuItem>
                <MenuItem value="Site">Site</MenuItem>
              </TextField>
            </FormControl> */}
              <FormControl fullWidth margin="normal">
                <Autocomplete
                  disabled={isVersionCheck}
                  disablePortal
                  readOnly={metaData.isf_doc_level === ''}
                  id={documentProps.isf_artifact_name}
                  options={list}
                  defaultValue={metaData.isf_artifact_name}
                  value={metaData.isf_artifact_name}
                  onChange={(event: any, newValue: string | null) => handleChangeArtifactName(newValue)}
                  renderInput={params => (
                    <TextField
                      {...params}
                      // onSelect={e => {
                      //   handleChangeArtifactName(e);
                      // }}
                      onClick={e => {
                        handleClickArtifactName(e);
                      }}
                      // onChange={e => setMetaData({ ...metaData, tmf_artifact_name: e.target.value })}
                      required
                      label="Artifact Name"
                      variant="standard"
                    />
                  )}
                />
              </FormControl>
              <FormControl fullWidth margin="normal">
                <TextField
                  disabled={isVersionCheck}
                  id={documentProps.isf_type}
                  label="Type"
                  variant="standard"
                  value={metaData.isf_document_type ? metaData.isf_document_type : metaData.isf_doc_type}
                />
              </FormControl>
              <FormControl fullWidth margin="normal">
                <TextField
                  disabled
                  id={date}
                  label="Upload Date"
                  variant="standard"
                  defaultValue={date}
                  type="text"
                  value={moment(new Date(metaData.isf_doc_viewer_date)).format(userPreferedDateFormat.toUpperCase())}
                  onChange={e => setMetaData({ ...metaData, isf_doc_date: e.target.value })}
                />
              </FormControl>
            </Grid>
            <Grid item md={4} sx={{ paddingTop: '0 !important' }}>
              <FormControl fullWidth margin="normal">
                <TextField
                  disabled={isVersionCheck}
                  id={documentProps.isf_doc_milestone}
                  label="Milestone"
                  variant="standard"
                  defaultValue={metaData.isf_doc_milestone}
                  value={metaData.isf_doc_milestone}
                />
              </FormControl>
              <FormControl fullWidth margin="normal">
                <TextField
                  disabled={isVersionCheck}
                  id={documentProps.isf_subtype}
                  label="Subtype"
                  variant="standard"
                  value={metaData.isf_document_subtype ? metaData.isf_document_subtype : metaData.isf_doc_subtype}
                />
              </FormControl>

              <FormGroup>
                <FormControlLabel
                  sx={{ pl: 1.5 }}
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={handleChangeCheck}
                      disabled={metaData.isf_doc_viewer_includes_phi || disablePHI}
                    />
                  }
                  label="Include PHI?"
                />
              </FormGroup>

              {/* <FormControl fullWidth margin="normal">
              <TextField
                id={documentProps.isf_doc_viewer_department}
                select
                label="Department"
                defaultValue={metaData.isf_doc_viewer_department}
                value={metaData.isf_doc_viewer_department}
                variant="standard"
                onChange={e => {
                  handleDepartmentChange(e);
                }}
              >
                <MenuItem value="Clinical Operations- Site management">Clinical Operations- Site management</MenuItem>
                <MenuItem value="Clinical Operations- Study management">Clinical Operations- Study management</MenuItem>
                <MenuItem value="Data Management">Data Management</MenuItem>
                <MenuItem value="Biometrics">Biometrics</MenuItem>
                <MenuItem value="Clinical Development">Clinical Development</MenuItem>
              </TextField>
            </FormControl> */}
            </Grid>
            <PopupComponent
              open={openPHI}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              child={true}
            >
              <IncludePHIDialog
                setOpenPHI={setOpenPHI}
                handleClosePHI={handleClosePHI}
                setChecked={setChecked}
                setDisablePHI={setDisablePHI}
                metaData={metaData}
                setMetaData={setMetaData}
              />
            </PopupComponent>
            <PopupComponent maxWidth="sm" open={open} child={true}>
              <RedactedCertifiedDialog
                setOpen={setOpen}
                handleClosePHI={handleClosePHI}
                setDisablePHI={setDisablePHI}
                metaData={metaData}
                setMetaData={setMetaData}
                setChecked={setChecked}
              />
            </PopupComponent>
            <Grid item md={12} className="button-actions">
              <Grid container spacing={2}>
                <Grid item md={12} display="flex" justifyContent="flex-end">
                  <Stack direction="row" spacing={2}>
                    <Button
                      href="#contained-buttons"
                      className="grey-btn"
                      onClick={handleClose}
                      disabled={isProcessing}
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={() => handleUpdateFile(metaData)}
                      disabled={!metaData.isf_artifact_number || !metaData.isf_document_name.trim() || isProcessing}
                    >
                      Save
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
      <PopupComponent
        open={openConfirmExit}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
        child={true}
      >
        <DialogTitle id="alert-dialog-title">
          <b>Please Confirm</b>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            All unsaved changes will be lost. Are you sure you want to exit before saving your changes?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenConfirmExit(false);
            }}
            className="grey-btn"
          >
            CLOSE
          </Button>
          <Button
            onClick={() => {
              setOpenEdit(false);
              setOpenConfirmExit(false);
            }}
          >
            EXIT
          </Button>
        </DialogActions>
      </PopupComponent>
    </>
  );
};
export default React.memo(EditMetadataModal);
